import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { ChartModel } from './Chart.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { ExchangeComponent } from '../../../gotx/components/Exchange/Exchange.component';
import { ProductComponent } from '../../../gotx/components/Product/Product.component';
import { StockComponent } from '../../../gotx/components/Stock/Stock.component';
import { GotxChartComponent } from '../../components/gotx-chart/gotx-chart.component';

const customCss: string = '';

@Component({  
  selector: 'app-Chart',
  templateUrl: './Chart.component.html'
})
export class ChartComponent extends FormComponent implements OnInit, AfterViewInit {
  @ViewChild('cstmExchange', { static: false }) cstmExchange: ExchangeComponent;
  @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
  @ViewChild('cmbStock', { static: false }) cmbStock: StockComponent;
  @ViewChild('btnSubmit', { static: false }) btnSubmit: ButtonComponent;
  @ViewChild('gotxChartComp', { static: false}) gotxChartComp: GotxChartComponent;
  @Input('params') params: any = null;
  skeletonContentLoaded = false;
  exchange: string = '';
  product: string = '';
  symbol: string = '';
  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      this.cstmExchange.revalidate(),
      this.cstmProduct.revalidate(),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock) {
    super(services);
    this.value = new ChartModel();
    this.componentCode = 'Chart';
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
    this.cstmExchange.setReadOnly(readOnly);
    this.cstmProduct.setReadOnly(readOnly);
  }
  async onFormLoad() {
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    this.setDependencies();
    this.reloadStock();

    if (this.params) {
      this.exchange = this.params.exchange;
      this.product = this.params.product;
      this.symbol = this.params.symbol;

      // console.log("In Chart Page");
      // console.log(this.exchange, this.product, this.symbol);

      this.cstmExchange.cmbExchange.setValue(this.params.exchange);
      this.cstmProduct.cmbProduct.setValue(this.params.product);
      this.cmbStock.gotxInput.val(this.params.symbol);
      // this.symbol = this.getSymbol();
    }
  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'Chart';
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.additionalInfo['cstmExchange_desc'] = this.cstmExchange.getFieldInfo();
    this.additionalInfo['cstmProduct_desc'] = this.cstmProduct.getFieldInfo();
    return this.additionalInfo;
  }
  getFieldValue() {
    this.value.cstmExchange = this.cstmExchange.getFieldValue();
    this.value.cstmProduct = this.cstmProduct.getFieldValue();
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.cstmExchange.setValue(inputValue['cstmExchange'], inputDesc['cstmExchange_desc']);
    this.cstmProduct.setValue(inputValue['cstmProduct'], inputDesc['cstmProduct_desc']);
    this.value = new ChartModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  ngOnInit() {
    if (this.formCode == undefined) { this.formCode = 'Chart'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
    this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'Chart_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('Chart_customCss');
    styleElement.parentNode.removeChild(styleElement);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.value.cstmExchange = this.cstmExchange.getFieldValue();
      this.cstmExchange.valueChangeUpdates().subscribe((value) => { this.value.cstmExchange = value; });
      this.value.cstmProduct = this.cstmProduct.getFieldValue();
      this.cstmProduct.valueChangeUpdates().subscribe((value) => { this.value.cstmProduct = value; });
      this.onFormLoad();
      this.checkForHTabOverFlow();
      // this.gotxChartComp.getChartData();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.cstmExchange.clearError();
    this.cstmProduct.clearError();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.cstmExchange.onReset();
    this.cstmProduct.onReset();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new ChartModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async cstmExchange_exchSelected() {
    this.cstmProduct.updateProductList(this.cstmExchange.cmbExchange.getFieldValue());
    this.reloadStock();
  }
  async cstmProduct_productSelected() {
    this.reloadStock();
  }
  async cmbStock_stockSelected() {
    // console.log("stockchanged");
    // this.exchange = this.cstmExchange.cmbExchange.getFieldValue();
    // this.product = this.cstmProduct.cmbProduct.getFieldValue();
    // this.symbol = this.getSymbol();
    // this.gotxChartComp.getChartData(this.cstmExchange.cmbExchange.getFieldValue(), this.getSymbol());
  }
  async btSubmit_click() {
    // this.exchange = this.cstmExchange.cmbExchange.getFieldValue();
    // this.product = this.cstmProduct.cmbProduct.getFieldValue();
    // this.symbol = this.getSymbol();
    // this.gotxChartComp.getChartData(this.cstmExchange.cmbExchange.getFieldValue(), this.getSymbol());
  }

  fieldDependencies = {
  }

  reloadStock() {
    if (this.cstmExchange != undefined) {
      let exch = this.cstmExchange.cmbExchange.getFieldValue();
      let pdct = this.cstmProduct.cmbProduct.getFieldValue();
      if (typeof pdct == 'object' ){
        pdct = pdct.text
    }
      this.cmbStock.gotxInput.val("");
      this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, exch, pdct);
    }
  }
  getSymbol() {
    if (this.cmbStock.gotxInput.val().label) {
      return this.cmbStock.gotxInput.val().label;
    } else {
      return this.cmbStock.gotxInput.val();
    }
  }

}